import { render, staticRenderFns } from "./PovijestBodova.vue?vue&type=template&id=65f42644&scoped=true&"
import script from "./PovijestBodova.vue?vue&type=script&lang=js&"
export * from "./PovijestBodova.vue?vue&type=script&lang=js&"
import style0 from "./PovijestBodova.vue?vue&type=style&index=0&id=65f42644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f42644",
  null
  
)

export default component.exports